import React from 'react';
import I18n from 'i18n-js';
import SessionPopup from '@/components/common/SessionPopup';
import Icon from '@/components/ui/Icon';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

// AIDEV-NOTE: PLAT-16784 — Shown to a student after the teacher removes them from an active
// Teacher-Paced Mode session. Mirrors SessionEndedPopup: dismissable via X, overlay click, or
// the Close button; dismissing returns the student to free navigation on the current slide.
const RemovedFromSessionPopup = ({ isOpen, onClose }: Props) => (
  <SessionPopup
    body={I18n.t('removed_from_session_body')}
    headline={{
      id: 'removed-from-session-headline',
      text: I18n.t('removed_from_session_headline'),
    }}
    icon={<Icon icon="InfoAlternate" size={30} />}
    isOpen={isOpen}
    primaryButton={{
      onClick: onClose,
      text: I18n.t('removed_from_session_close_button'),
    }}
    onClose={onClose}
  />
);

export default RemovedFromSessionPopup;
